import { render, staticRenderFns } from "./ProductLimitStrategy.vue?vue&type=template&id=e88f2dd4"
import script from "./ProductLimitStrategy.vue?vue&type=script&lang=js"
export * from "./ProductLimitStrategy.vue?vue&type=script&lang=js"
import style0 from "./ProductLimitStrategy.vue?vue&type=style&index=0&id=e88f2dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports